import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

export const ON_HOLD_STEPS = {
  INTRO: 'intro',
  MAKE_COUNTER_OFFER_REASONS: 'makeCounterOffer',
  MAKE_COUNTER_OFFER_DETAILS: 'makeCounterOfferDetails',
  CUSTOMER_ACTION: 'customerActionNeeded',
  TRANSPORT_ISSUE: 'transportIssue',
  REFUSE_ITEM: 'refuseItem',
} as const

export const COUNTEROFFER_ROLES = {
  ADMIN: 'ADMIN',
  MERCHANT: 'MERCHANT',
} as const

// These 4 values are used only in tests as runtime values are stores in useBuybackConfig.ts
export const COUNTRIES_WITH_GDPR = [
  MarketCountryCode.FR,
  MarketCountryCode.ES,
  MarketCountryCode.DE,
  MarketCountryCode.GB,
]

export const COUNTRIES_WITHOUT_GDPR = [MarketCountryCode.US]

export const COUNTRIES_WITH_SMS_CONSENT = [MarketCountryCode.US]

export const COUNTRIES_WITHOUT_SMS_CONSENT = [
  MarketCountryCode.FR,
  MarketCountryCode.ES,
  MarketCountryCode.DE,
  MarketCountryCode.GB,
]

export const REFURBISHER_ACTIONS = {
  VALIDATE: 'refurbisherValidateOrder',
  VALIDATE_ACTION: 'refurbisherValidateOrderAction',
  PUT_ON_HOLD: 'refurbisherPutOnHoldOrder',
  COUNTER_OFFER: 'refurbisherNewCounterOffer',
}

export const SWAP_INFO_MESSAGE = {
  SWAP_POPULAR: '[BUYBACK][API][SWAP] Error in swap popular searches',
  SWAP_SEARCH: '[BUYBACK][API][SWAP] Error in swap search',
  DELETE_SWAP: '[BUYBACK][API][SWAP] Error deleting swap',
}

export const BUYBACK_SHIPPING_MODE = {
  KIT: 'BULLE',
  NEW_KIT: 'KIT',
  SELF_PACKAGED: 'COLISSIMO',
  NEW_SELF_PACKAGED: 'SELF_PACKAGED',
  QR_CODE: 'QR_CODE',
} as const

export const MODAL_NAMES = {
  GRADING_WITH_IA: 'GRADING_WITH_IA',
}

export const PAYMENT_INFOS_TYPES = {
  IDENTITY_DOCUMENT: 'IDENTITY_DOCUMENT',
  BANK_DETAILS: 'BANK_DETAILS',
  PERSONAL_IDENTIFICATION: 'PERSONAL_IDENTIFICATION',
  TAX_IDENTIFICATION_NUMBER: 'TAX_IDENTIFICATION_NUMBER',
  DATE_OF_BIRTH: 'DATE_OF_BIRTH',
} as const

export const PAYMENT_INFOS_OPTIONS = {
  ID_CARD: 'ID_CARD',
  PASSPORT: 'PASSPORT',
  DRIVING_LICENCE: 'DRIVING_LICENCE',
  ACH: 'ACH',
  BACS: 'BACS',
  SEPA: 'SEPA',
  SSN: 'SSN',
  SOCIAL_SECURITY_NUMBER: 'SOCIAL_SECURITY_NUMBER',
  DRIVING_LICENCE_NUMBER: 'DRIVING_LICENCE_NUMBER',
} as const
